import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PequenosGruposDto } from "@/interfaces/pequenos-grupos.interface";

export interface PequenosGruposState {
  PequenosGrupos: PequenosGruposDto[];
  PequenosGruposId: number | null;
}

const initialState: PequenosGruposState = {
  PequenosGrupos: [],
  PequenosGruposId: null,
};

export const pequenosGruposSlice = createSlice({
  name: "pequenosGrupos",
  initialState,
  reducers: {
    SetPequenosGrupos: (state, action: PayloadAction<PequenosGruposDto[]>) => {
      state.PequenosGrupos = action.payload;
    },
    SetPequenosGruposId: (state, action: PayloadAction<number>) => {
      state.PequenosGruposId = action.payload;
    },
  },
});

export const { SetPequenosGrupos, SetPequenosGruposId } =
  pequenosGruposSlice.actions;
export const pequenosGruposReducer = pequenosGruposSlice.reducer;
